export default "/app/themes/macleod/public/images/filters-icon.svg?41b336b6a214dd74cf5dc17f83b97dc4";